import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as $ from "jquery";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import * as moment from "moment";
import Swal from "sweetalert2";
declare var Simditor: any;

@Component({
  selector: "app-laudo-registration",
  templateUrl: "./laudo-registration.component.html",
  styleUrls: ["./laudo-registration.component.css"],
})
export class LaudoRegistrationComponent implements OnInit {
  @Input() prontuario: any = {};
  @Input() presenca: any = {};
  @Output() goBack = new EventEmitter();
  @Output() retornoPost: EventEmitter<any> = new EventEmitter();
  @Output() listarLaudos: EventEmitter<any> = new EventEmitter();
  laudo: any = {};

  toolbar: any = [
    "title",
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "fontScale",
    "color",
    "ol",
    "ul",
    "table",
    "hr",
    "indent",
    "outdent",
    "alignment",
  ];

  constructor(private authService: AuthService, public service: ApiService) {
    Simditor.locale = "en-US";
  }

  ngOnInit() {
    var that = this;
    setTimeout(() => {
      var descricao = new Simditor({
        textarea: $("#descricaoLaudo"),
        upload: false,
        tabIndent: true,
        toolbar: that.toolbar,
        toolbarFloat: true,
      });
    }, 1000);
  }

  voltar = () => {
    this.laudo = {};
    $("#descricaoLaudo").val("");
    this.goBack.emit();
  };

  selecionarTipoLaudo(tipo) {
    this.laudo.tipo_laudo = tipo;
    if (this.laudo.tipo_laudo == 1) {
      var that = this;
      setTimeout(() => {
        var descricao = new Simditor({
          textarea: $("#descricaoLaudo"),
          upload: false,
          tabIndent: true,
          toolbar: that.toolbar,
          toolbarFloat: true,
        });
      }, 1000);
      $("#descricaoLaudo").val("");
    } else {
      this.laudo.tipo_laudo = "PADRAO";
    }
  }

  salvarLaudo() {
    Swal.fire({
      title: "Favor aguarde",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    Swal.showLoading();

    var laudoLivre = {
      presenca_id: this.presenca.id,
      tipo_laudo: 1,
      texto: $("#descricaoLaudo").val(),
    };

    this.service
      .Post(`Prontuario/${this.prontuario.id}/ProntuarioLaudo`, laudoLivre)
      .then((result) => {
        this.retornoPost.emit();
        this.laudo = {};
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Laudo salvo com sucesso.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.laudo = {};
            $("#descricaoLaudo").val("");
            this.retornoPost.emit();
            this.listarLaudos.emit();
            Swal.close();
            this.voltar();
          }
        });
      })
      .catch((res) => {
        if (res.status == 400) {
          Swal.fire("Erro", res.error, "error");
        } else {
          Swal.fire("Erro", "Erro ao salvar o laudo.", "error");
        }
      });
  }
}
